// extracted by mini-css-extract-plugin
module.exports = {"button":"_8ae61170","isCircleVariation":"_77de94aa","prev":"_15b9e4f8","next":"_61664991","isCircleWithChevronVariant":"_39e53958","isFullVariation":"_e8f6b09f","icon":"_2ef689a9"};